module.exports = __webpack_public_path__ + "img/field-dark-2.9eedbb42.svg";